import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WelcomeComponent } from './shell/welcome/welcome.component';
import { ShellWrapperComponent } from './shell/shell.component';

const routes: Routes = [
    {
        path: '',
        component: ShellWrapperComponent,
        children: [
            { path: ':id', component: WelcomeComponent },
            { path: 'room', loadChildren: () => import('./shell/waiting-room/waiting-room.module').then(m => m.WaitingRoomModule) },
            { path: '**', component: WelcomeComponent }
        ]
    },
    { path: '**', redirectTo: 'welcome' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
